export default __webpack_public_path__ + "Duplicate_white.svg";